<template>
  <card :bodyClasses="['skinny-padding']">
    <div class="week-overview-container">
      <div
        class="course-icon"
        v-tooltip="course.Name"
      >
        <!-- Avatar -->
        <div class="course-image" >
          <img
            :alt="course.Name"
            :src="getCourseImage(course)"
          />
        </div>
      </div>
      <div class="middle-section">
        <h4 class="mb-0">
          <i
            class="fa fa-star"
            v-if="week.Major"
            v-tooltip="'Major'"
          />
          Week {{week.WeekNumber}}
        </h4>
        <p class="text-sm text-muted mb-0">
          {{startDate}} {{team ? '' : 'to'}} {{team ? '' : endDate}}
        </p>
        <div class="mr-4">
          <badge
            class="badge-dot mr-4"
            :type="statusClass"
          >
            <i :class="`bg-${statusClass}`"/>
            <span class="status">
              {{status}}
            </span>
          </badge>
          <badge
            class="badge-dot"
            :type="weekAwardStatus"
            @click.native="awardsVisible = !awardsVisible"
          >
            <i :class="`bg-${weekAwardStatus}`" />
            <span class="status">
              Awards
            </span>
          </badge>
        </div>
      </div>
      <div
        class="edit-button"
        v-if="team"
      >
        <i
          class="fa fa-calendar add-scores text-light"
          v-tooltip.left="'Edit Schedule'"
          @click="$emit('editSchedule', week.id)"
        />
      </div>
    </div>
    <div
      class="awards-info"
      v-if="awardsVisible"
    >
      <div v-if="league.showLD !== false">
        <label class="award-label">
          Longest Drive
        </label>
        <div class="award">
          <base-checkbox
            class="award-checkbox"
            v-model="model.ldAwarded"
          />
          <input
            type="text"
            placeholder="Initial"
            class="mini-textbox"
            v-model="model.ldInitial"
          />
          <base-button
            type="success"
            size="sm"
            class="button"
            v-if="ldUnsaved"
            @click="saveLD"
          >
            Save
          </base-button>
        </div>
      </div>

      <div v-if="league.showCTP !== false">
        <label class="award-label">
          Closest To Pin
        </label>
        <div class="award">
          <base-checkbox
            class="award-checkbox"
            v-model="model.ctpAwarded"
          />
          <input
            type="text"
            placeholder="Initial"
            class="mini-textbox"
            v-model="model.ctpInitial"
          />
          <base-button
            type="success"
            size="sm"
            class="button"
            v-if="ctpUnsaved"
            @click="saveCTP"
          >
            Save
          </base-button>
        </div>
      </div>

      <div v-if="league.showDA !== false">
        <label class="award-label">
          Discretionary Award
        </label>
        <div class="award">
          <base-checkbox
            class="award-checkbox"
            v-model="model.daAwarded"
          />
          <input
            type="text"
            placeholder="Initial"
            class="mini-textbox"
            v-model="model.daInitial"
          />
          <base-button
            type="success"
            size="sm"
            class="button"
            v-if="daUnsaved"
            @click="saveDA"
          >
            Save
          </base-button>
        </div>
      </div>
    </div>
  </card>
</template>
<script>
import moment from 'moment';
import ErrorHandler from '@/helpers/AuthError';

export default {
  name: 'WeekOverviewCard',
  props: {
    week: Object,
    team: Boolean,
    league: Object,
  },
  data() {
    return {
      course: {
        Name: '',
        image: {
          id: '',
        },
      },
      awardsVisible: false,
      model: {
        ldAwarded: false,
        ctpAwarded: false,
        daAwarded: false,
        ldInitial: '',
        ctpInitial: '',
        daInitial: '',
      },
      originalValue: {
        ldAwarded: false,
        ctpAwarded: false,
        daAwarded: false,
        ldInitial: '',
        ctpInitial: '',
        daInitial: '',
      },
    };
  },
  mounted() {
    this.getCourse();
    this.setOriginalState();
  },
  watch: {
    week() {
      this.setOriginalState();
    },
  },
  computed: {
    ldUnsaved() {
      if (this.model.ldAwarded !== this.originalValue.ldAwarded) {
        return true;
      }
      if (this.model.ldInitial !== this.originalValue.ldInitial) {
        return true;
      }
      return false;
    },
    ctpUnsaved() {
      if (this.model.ctpAwarded !== this.originalValue.ctpAwarded) {
        return true;
      }
      if (this.model.ctpInitial !== this.originalValue.ctpInitial) {
        return true;
      }
      return false;
    },
    daUnsaved() {
      if (this.model.daAwarded !== this.originalValue.daAwarded) {
        return true;
      }
      if (this.model.daInitial !== this.originalValue.daInitial) {
        return true;
      }
      return false;
    },
    leagueDaysOpen() {
      if (this.league && this.league.daysOpen) {
        return this.league.daysOpen;
      }
      return 7;
    },
    leagueExtraDaysOpen() {
      if (this.league && this.league.extraDaysOpen) {
        return this.league.extraDaysOpen;
      }
      return 7;
    },
    startDate() {
      return moment(this.week.Start).format('MMM. D');
    },
    endDate() {
      return moment(this.week.Start).add(this.leagueDaysOpen - 1, 'days').format('MMM. D');
    },
    status() {
      if (moment(this.week.Start).isAfter(moment())) {
        return 'upcoming';
      }
      if (moment(this.week.Start).isBefore(moment())
        && moment(this.week.Start).add(this.leagueDaysOpen, 'days').isAfter(moment())
      ) {
        return 'open';
      }
      if (moment(this.week.Start).isBefore(moment())
        && moment(this.week.Start).add(this.leagueDaysOpen + this.leagueExtraDaysOpen, 'days').isAfter(moment())
      ) {
        return 'closing soon';
      }

      return 'closed';
    },
    statusClass() {
      switch (this.status) {
        case 'upcoming':
          return 'info';
        case 'open':
          return 'success';
        case 'closing soon':
          return 'warning';
        default:
          return 'danger';
      }
    },
    weekAwardStatus() {
      const statuses = [];
      if (this.league.showLD) {
        statuses.push(this.originalValue.ldAwarded);
      }
      if (this.league.showCTP) {
        statuses.push(this.originalValue.ctpAwarded);
      }
      if (this.league.showDA) {
        statuses.push(this.originalValue.daAwarded);
      }

      if (statuses.every(i => i === true)) {
        return 'success';
      }
      if (statuses.some(i => i === true)) {
        return 'warning';
      }
      return 'danger';
    },
  },
  methods: {
    setOriginalState() {
      this.originalValue.ldAwarded = this.week.ldPrizeAwarded;
      this.originalValue.ldInitial = this.week.ldPrizeAwardedInitial;
      this.originalValue.ctpAwarded = this.week.ctpPrizeAwarded;
      this.originalValue.ctpInitial = this.week.ctpPrizeAwardedInitial;
      this.originalValue.daAwarded = this.week.daPrizeAwarded;
      this.originalValue.daInitial = this.week.daPrizeAwardedInitial;

      this.model.ldAwarded = this.week.ldPrizeAwarded;
      this.model.ldInitial = this.week.ldPrizeAwardedInitial;
      this.model.ctpAwarded = this.week.ctpPrizeAwarded;
      this.model.ctpInitial = this.week.ctpPrizeAwardedInitial;
      this.model.daAwarded = this.week.daPrizeAwarded;
      this.model.daInitial = this.week.daPrizeAwardedInitial;
    },
    saveLD() {
      this.axios
        .put(`/weeks/${this.week.id}`, {
          ldPrizeAwarded: this.model.ldAwarded,
          ldPrizeAwardedInitial: this.model.ldInitial,
        }, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((result) => {
          this.originalValue.ldAwarded = result.data.ldPrizeAwarded;
          this.originalValue.ldInitial = result.data.ldPrizeAwardedInitial;
        });
    },
    saveCTP() {
      this.axios
        .put(`/weeks/${this.week.id}`, {
          ctpPrizeAwarded: this.model.ctpAwarded,
          ctpPrizeAwardedInitial: this.model.ctpInitial,
        }, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((result) => {
          this.originalValue.ctpAwarded = result.data.ctpPrizeAwarded;
          this.originalValue.ctpInitial = result.data.ctpPrizeAwardedInitial;
        });
    },
    saveDA() {
      this.axios
        .put(`/weeks/${this.week.id}`, {
          daPrizeAwarded: this.model.daAwarded,
          daPrizeAwardedInitial: this.model.daInitial,
        }, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((result) => {
          this.originalValue.daAwarded = result.data.daPrizeAwarded;
          this.originalValue.daInitial = result.data.daPrizeAwardedInitial;
        });
    },
    getCourseImage(course) {
      if (course && course.image.thumb !== '') {
        return `${course.image.thumb}`;
      }
      return '';
    },
    getCourse() {
      if (!this.week.course) {
        return;
      }
      this.axios
        .get(`/courses/${this.week.course}`, {
          headers: {
            Authorization: `Bearer ${this.$store.state.authToken}`,
          },
        })
        .then((response) => {
          this.course = response.data;
        })
        .catch((error) => {
          ErrorHandler.handleError(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
  .button {
    margin-left: .5rem;
  }
  .award-label {
    font-size: .75rem;
    font-weight: bold;
    margin-bottom: 0;
  }
  .award {
    display: flex;
    align-items: center;

    .mini-textbox {
      margin-bottom: 0;
      margin-left: -1.25rem;
      border-radius: .35rem;
      border: 1px solid #d3d3d3;
      padding: 0 .25rem;
    }
  }

  .awards-info {
    padding-top: .5rem;
    padding-bottom: .5rem;
  }

  .week-overview-container{
    display: flex;
    align-items: center;

    .middle-section{
      flex: 1;
    }

    .course-icon{
      margin-right: 1rem;
    }

  }

  .course-image{
    width: 60px;
    height: 60px;
    display: block;
    border-radius: 50%;
    overflow: hidden;
    position: relative;


    img{
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  .status{
    text-transform: uppercase;
    font-size: .75rem;
  }
  .add-scores{
    cursor: pointer;
  }
  .badge-warning{
    color: #ffb200 !important;
  }
  .bg-warning{
    background-color: #ffb200 !important;
  }
</style>
<style lang="scss">
.skinny-padding{
  padding: .5rem 1rem;
}
</style>
